export default {
// baseUrl: 'http://7ed9-106-51-16-148.ngrok.io/swagger/index.html'
// baseUrl: 'https://devapi.symptom.clinic'
 baseUrl: 'https://devapi.symptom.clinic'
};